'use es6';

import TinyMCE from 'tinymce';
import { HS_NEWLINE } from '../constants/plugins';
import { BOGUS_BR, BOGUS_DATA_ATTR } from '../utils/dom';
import { OUTER_BLOCK_ELEMENTS, NEWLINE_BLOCK_ELEMENTS } from '../constants/hsnewline';
const isLastValidSiblingNode = node => {
  let nextSibling = node.nextSibling;
  while (nextSibling) {
    if (nextSibling.nodeName === '#text') {
      if (nextSibling.nodeValue) break; // Next sibling is a valid text node
    } else if (!nextSibling.getAttribute(BOGUS_DATA_ATTR) && nextSibling.nodeName !== 'BR') {
      break; // Next sibling is not a tinymce bogus node (carets, resize handlers, etc.) or <br>
    }
    nextSibling = nextSibling.nextSibling;
  }
  return !nextSibling;
};

// Returns the wrapper node if it is the last node in a block
const getLastNodeInBlock = (editor, node) => {
  const body = editor.getBody();
  let wrapperEl = node;
  while (wrapperEl !== body) {
    if (!isLastValidSiblingNode(wrapperEl)) {
      wrapperEl = null;
      break;
    }
    if (OUTER_BLOCK_ELEMENTS.includes(wrapperEl.parentNode.nodeName) || wrapperEl.parentNode === body) {
      break;
    }
    wrapperEl = wrapperEl.parentNode;
  }
  return wrapperEl;
};

// Always inserts a newline beneath certain elements (tables, blockquotes, pre) or if
// the it is the last node inside the outer block element [pre|blockquote|td|body].
// Other items included are: [videos, embeds, images, callouts]
function newlinePlugin(editor) {
  editor.addCommand('hsInsertNewline', (ui, {
    target
  }) => {
    if (!target) return;
    const shouldAlwaysInsertNewline = NEWLINE_BLOCK_ELEMENTS.includes(target.nodeName);
    const wrapperNode = getLastNodeInBlock(editor, target);
    if (shouldAlwaysInsertNewline || wrapperNode) {
      const newlineNode = editor.dom.create('p', {}, BOGUS_BR);
      editor.dom.insertAfter(newlineNode, shouldAlwaysInsertNewline ? target : wrapperNode);
    }
  });
}
TinyMCE.PluginManager.add(HS_NEWLINE, newlinePlugin);